'use client'
import BreadCrumb from '@/components/BreadCrumb';
import { getAllLanguages, getRashiPredition } from '@/services/app.services'
import React, { useEffect, useState } from 'react'
import Image from 'next/image';
import { noto_sans, noto_serif, ubuntu } from '@/globalConstants';
import { Language, Prediction, PredictionCategory } from '@/globalTypes';
import dayjs from 'dayjs';
import { Menu } from '@mui/base/Menu';
import { MenuButton, AnimatedListbox } from '@/lib/globalHooks';
import Skeleton from '@mui/material/Skeleton/Skeleton';
import { KeyboardArrowDown } from '@mui/icons-material';
import MenuItem from '@mui/material/MenuItem/MenuItem';
import { usePathname } from 'next/dist/client/components/navigation';
import { Dropdown } from '@mui/base/Dropdown/Dropdown';
import dynamic from 'next/dist/shared/lib/dynamic';
const NudgeSection = dynamic(() => import('@/components/NudgeSection'));
const BASE_CLASS = "rashi"
const dummyData = [{
    "rashi": "Mesha Rashi",
    "date": "30 January 2025",
    "timestamp": 0,
    "rashi_image_url": '',
    "banner_image_url": '',
    "predictions": [],
    "lucky_number": [],
    "lucky_color_code": '',
    "lucky_color": '',
    "share_text_title": '',
    "week": '',
    "week_key": '',
    "is_weekly": false,
    "week_title": ''
}]
const RashiPrediction = ({ rashiSlug }: { rashiSlug: string }) => {
    const pathname = usePathname();
    const dates = [dayjs().subtract(1, 'day'), dayjs(), dayjs().add(1, 'day'), dayjs().add(2, 'day')];
    const [openMenu, setOpenMenu] = useState(false)
    const [predictions, setPredictions] = useState<Prediction[]>([])
    const [languages, setLanguages] = useState<Language[]>([])
    const [selectedPrediction, setSelectedPrediction] = useState<Prediction>(dummyData[0])
    const [selectedLanguage, setSelectedLanguage] = useState(("en"));
    const fetchPrediction = async (dates: string, rashi: string, language: string) => {

        let latestPredection = await getRashiPredition(dates, rashi, language);
        if (latestPredection.length) {
            setPredictions([...latestPredection]);
        }
        else
            console.error("Oops...! We encoundered an error while fetching your predictions");
    }

    useEffect(() => {
        if (rashiSlug.length && selectedLanguage) {
            fetchPrediction(dates.map((date) => date.format("DD/MM/YYYY")).join(','), rashiSlug, selectedLanguage);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [rashiSlug, selectedLanguage])

    useEffect(() => {
        console.log(predictions);
        if (predictions.length) {
            const predictionForToday = predictions.filter(prediction => {
                return dayjs(prediction.timestamp * 1000).date() === dayjs().date()
            });
            setSelectedPrediction(predictionForToday[0]);
        }
    }, [predictions])

    useEffect(() => {
        (async () => {
            let languages = await getAllLanguages();
            setLanguages(languages);
        })()
        let userSelectedLanguage = localStorage.getItem('userSelectedLanguage');
        if (userSelectedLanguage)
            setSelectedLanguage(userSelectedLanguage);
    }, [])
    return (
        <>
            <div className={`${BASE_CLASS} pt-[1rem] pb-[4rem] px-[1rem]  md:py-[4rem] w-[95%] md:w-[90%]  2xl:w-[70%] m-auto grid  lg:grid-cols-2 lg:gap-[64px]`}>
                <div className={`${BASE_CLASS}__container flex flex-col gap-[1rem] md:gap-[1.5rem]    `}>
                    {predictions.length ? <BreadCrumb pathname={pathname}></BreadCrumb> : <Skeleton variant='text' width={'300px'} className='h-[20px]' ></Skeleton>}
                    <div className={`${BASE_CLASS}__rashi-list-container grid  gap-[40px]  items-center`}>
                        <div className={`${BASE_CLASS}__header grid gap-[2rem] lg:gap-[1rem] text-[#1D4749] `}>
                            <div className={`${BASE_CLASS}__header__heading  flex items-baseline gap-[8px] justify-between `}>
                                <h1 className={` ${noto_serif.variable} font-[600] text-[2rem]`}>
                                    {predictions.length ? selectedPrediction.rashi : <Skeleton variant='rounded' width={'300px'} className='h-[20px] lg:h-[2rem]' ></Skeleton>}
                                </h1>
                                {predictions.length ?
                                    <Dropdown open={openMenu}>
                                        <div onClick={() => {
                                            document.querySelector(".translation-menu-arrow")?.classList.toggle('rotate-180');
                                            setOpenMenu(!openMenu)
                                        }} className=''>
                                            <MenuButton className=' flex justify-between text-black bg-white gap-3  rounded-[0.1rem] items-baseline'>
                                                <Image src={`${process.env.NEXT_PUBLIC_ASSETS_BASE_URL}/translateIcon.svg`} alt="" width={20} height={20} className='menu-arrow '></Image>
                                                <KeyboardArrowDown sx={{ color: "black" }} className='translation-menu-arrow  transition ease-in-out duration-500'></KeyboardArrowDown>
                                            </MenuButton>
                                        </div>
                                        <Menu slots={{ listbox: AnimatedListbox }} className='rashi-language-selector' >
                                            {
                                                languages.map((item) => {
                                                    return <div key={Math.random()} onClick={() => {
                                                        document.querySelector(".translation-menu-arrow")?.classList.toggle('rotate-180', false);
                                                        setOpenMenu(false);
                                                        setSelectedLanguage(item.key);
                                                        localStorage.setItem("userSelectedLanguage", item.key);
                                                    }}>
                                                        <MenuItem sx={{ padding: '16px' }} >
                                                            {item.value}
                                                        </MenuItem>
                                                    </div>
                                                })
                                            }
                                        </Menu>
                                    </Dropdown>
                                    : <Skeleton variant='rectangular' width={'100px'} className='h-[45px]' ></Skeleton>}
                            </div>
                            <div className='flex justify-center lg:hidden'>
                                {selectedPrediction.banner_image_url.length ? <Image src={selectedPrediction.rashi_image_url} alt='rashi Banner' width={480} height={480} className=' lg:hidden' priority={true}></Image> : <Skeleton variant='circular' width={'480px'} height={'480px'} className='lg:hidden' ></Skeleton>}
                            </div>
                        </div>
                        <div className='grid  lg:gap-[1rem] '>
                            <div className={`${noto_sans.variable} font-[500]  text-[14px] lg:text-[16px] text-justify  grid gap-[2rem] lg:gap-0 `}>
                                <div className='date-selector flex gap-[4px] justify-around lg:justify-start overflow-x-scroll h-full overflow-y-hidden '>
                                    {
                                        predictions.map((prediction, index) => {
                                            return (
                                                <div key={Math.random()} className=' relative inline-block whitespace-nowrap' onClick={() => { setSelectedPrediction(predictions[index]) }} >
                                                    <div className={` flex gap-[4px] py-[4px] px-[20px] border-[1px] border-[#EDE4DD] h-full items-center ${(prediction.date !== '' ? (prediction.date === selectedPrediction.date) : (selectedPrediction.week === prediction.week)) ? 'text-[#FFFFFF] bg-[#EE9322] scale-x-[110%] scale-y-[120%] ' : 'text-[#EE9322] bg-[#FFFFFF]'} rounded-lg lg:rounded-b-none cursor-pointer hover:scale-y-[120%] hover:scale-x-[110%] hover:bg-[#EE9322] hover:text-[#FFFFFF] transition ease-in-out duration-300`}>
                                                        {prediction.date ?
                                                            <div className='grid '>
                                                                <span>
                                                                    {(prediction.date === dayjs().format("DD MMMM YYYY")) && <p className={` font-[600] tracking-wide text-[12px] `}>TODAY</p>}
                                                                </span>
                                                                <span>{dayjs(prediction.timestamp * 1000).format('DD MMM')}</span>
                                                            </div>
                                                            : <div className='grid gap-2'>
                                                                <span>{prediction.week_title}</span>
                                                                <span>{prediction.week}</span>
                                                            </div>}
                                                    </div>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                                <div className='rashi-predictions py-[1.5rem] px-[1rem] grid gap-[1.5rem] border-[1px] border-[#E5E0DF] rounded-2xl lg:rounded-b-2xl lg:rounded-t-none bg-[#FFFFFF]'>
                                    <div className='lucky-numbers-and-color grid  grid-cols-2 2xl:grid-cols-3'>
                                        <div className={`${ubuntu.className} font-[500]  text-[14px] lg:text-[18px] grid gap-[12px]`}>
                                            <h1>LUCKY NUMBER</h1>
                                            <ul className='flex gap-[8px]'>
                                                {
                                                    selectedPrediction.lucky_number.length ? selectedPrediction.lucky_number.map((number: number) => {
                                                        return <li className={`h-[2.25rem] w-[2.25rem] text-[16px] rounded-3xl border-[1px] border-[#EE9322]  grid place-content-center `} key={Math.random()}>
                                                            {number}
                                                        </li>
                                                    }) : <>
                                                        <Skeleton variant='circular' width={'2.25rem'} className='h-[2.25rem]' ></Skeleton>
                                                        <Skeleton variant='circular' width={'2.25rem'} className='h-[2.25rem]' ></Skeleton>
                                                    </>
                                                }
                                            </ul>
                                        </div>
                                        <div className={`${ubuntu.className} font-[500] text-[14px] lg:text-[18px] grid gap-[12px]`}>
                                            <h1>LUCKY COLOUR</h1>
                                            <div className='flex gap-[8px] items-center'>
                                                {selectedPrediction.lucky_color_code === "" ?
                                                    <Skeleton variant='circular' width={'2.25rem'} className='h-[2.25rem]' ></Skeleton>
                                                    : <span className={`h-[2.25rem] w-[2.25rem]  rounded-3xl border-[1px] `}
                                                        style={
                                                            {
                                                                borderColor: selectedPrediction.lucky_color_code === "#FFFFFF" ? '#ADA8A8' : selectedPrediction.lucky_color_code,
                                                                backgroundColor: selectedPrediction.lucky_color_code
                                                            }} >
                                                    </span>}
                                                <span className={`${ubuntu.className} font-[500] text-[13px] tracking-wide  `} style={{ color: selectedPrediction.lucky_color_code === '#FFFFFF' ? '#3C3838' : selectedPrediction.lucky_color_code }}>
                                                    {selectedPrediction.lucky_color === "" ? <Skeleton variant='text' width={'100px'} className='h-[13px]' ></Skeleton> : selectedPrediction.lucky_color}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='predection-types grid gap-[40px] '>
                                        {
                                            selectedPrediction.predictions.length ? selectedPrediction.predictions.map((prediction: PredictionCategory) => {
                                                return (
                                                    <div key={Math.random()} className='flex gap-[12px]'>

                                                        <div className='text-[#272525] grid gap-[8px] w-full'>
                                                            <h2 className={`prediction-type-name ${ubuntu.className} font-[600] text-[14px]`}>
                                                                {prediction.name.toUpperCase().replaceAll("_", " ")}
                                                            </h2>
                                                            <p className={`prediction-text  ${noto_sans.variable}  text-[14px] leading-5 `}>
                                                                {prediction.split_response}
                                                            </p>
                                                        </div>
                                                    </div>)
                                            }) : new Array(7).fill(0).map(() => {
                                                return (
                                                    <div key={Math.random()} className='flex gap-[12px]'>

                                                        <div className='text-[#272525] grid gap-[8px] w-full'>

                                                            <Skeleton variant='text' width={'100px'} className='h-[20px]' ></Skeleton>
                                                            <div>
                                                                <Skeleton variant='text' width={'100%'} className='h-[12px]' ></Skeleton>
                                                                <Skeleton variant='text' width={'100%'} className='h-[12px]' ></Skeleton>
                                                                <Skeleton variant='text' width={'100%'} className='h-[12px]' ></Skeleton>
                                                            </div>


                                                        </div>
                                                    </div>)
                                            })
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='hidden lg:flex flex-col gap-[2rem] items-center'>
                    <div className='w-[480px] h-[480px]  hidden lg:block rounded-[50%]  overflow-hidden bg-white relative '>
                        {selectedPrediction.rashi_image_url.length ?
                            <Image src={selectedPrediction.rashi_image_url} alt='rashi Banner' width={480} height={480} className='   object-cover transition ease-in-out delay-150 duration-500' priority={true}></Image>
                            :
                            <Skeleton variant='circular' width={'480px'} height={'480px'} animation="wave" />
                        }
                    </div>
                    <h1 className={` flex flex-col text-center  `}>
                        <span className={`text-[2rem] font-[600] text-[#1D4749] ${noto_serif.variable} `}>{selectedPrediction.rashi}</span>
                        <span className={`text-[1.25rem] font-[500] text-[#8F8B8B] ${ubuntu.className} font-[500] `}>{pathname.split("/")[2].charAt(0).toUpperCase() + pathname.split("/")[2].slice(1)}</span>
                    </h1>
                </div>
            </div>
            <NudgeSection />
        </>
    )
}

export default RashiPrediction